const fetcher = require('components/conchita/js/cached_fetcher');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const validStatusList = ['CONTRACT', 'PENDING', 'REQUEST'];
const getBookingStatusFromSession = () => {
    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
    return bookingInfo.bookingStatus || '';
};
const isMmbValidStatus = (myTripStatus) => validStatusList.includes(getBookingStatusFromSession().toUpperCase() || myTripStatus);

module.exports = {
    preloadMmb({bookingId = '', mail = '', myTripStatus} = {}) {
        preloadModule();
        preloadContent();
        if (bookingId && mail && isMmbValidStatus(myTripStatus)) {
            fetcher.preload(`/service/users/managebookingtoken?bookingid=${bookingId}&email=${mail}`);
            fetcher.preload(`/service/bookingchangerequest/mybooking/${mail}/${bookingId}`);
        }
    },
    preloadMmbBase() {
        preloadModule();
        preloadContent();
    },
};

const preloadModule = () => {
    if (!Odigeo.Device.navigator.isIE) {
        import(/* webpackChunkName: "frontend-booking-management" */ '@edreamsodigeo/frontend-booking-management');
    }
};

const preloadContent = () => {
    websiteConfigCollection.getLoadedPromise().then(() => {
        fetcher.preload('/service/templates/getConchitaKeysFromCMS?moduleName=mmb');
    });
};
